export const SHIPMENT_TYPE_OPTIONS = [
  { value: 'E', label: 'Enviar' },
  { value: 'P', label: 'PickUp' },
  { value: 'S', label: 'Retiro en tienda' },
  { value: 'F', label: 'Flex' },
];

export const DELIVERY_TERM_OPTIONS = [
  { value: '48hs', label: '48 hs' },
  { value: 'NextDay', label: 'NextDay' },
  { value: 'SameDay', label: 'SameDay' },
  { value: 'SameDayExpress', label: 'SameDay Express' },
  { value: 'OneWeek', label: 'OneWeek' },
  { value: 'TwoWeeks', label: 'TwoWeeks' },
];

export const MAX_MASSIVE_ROWS = 200;

export const MASSIVE_SCOPES = {
  TENANT: 'tenant',
  MARKETPLACE: 'marketplace',
  STORE: 'store',
} as const;

export type MassiveScope = (typeof MASSIVE_SCOPES)[keyof typeof MASSIVE_SCOPES];

export const needsMarketplace = (scope: MassiveScope) =>
  scope === MASSIVE_SCOPES.TENANT;

export const needsStore = (scope: MassiveScope) =>
  scope !== MASSIVE_SCOPES.STORE;

export const storeIsRequired = (scope: MassiveScope) =>
  scope === MASSIVE_SCOPES.MARKETPLACE;
